import { createIcon } from './icon-utils';

export const RedoIcon = createIcon({
  path: 'M19.967 9.936h-5.154a.75.75 0 1 1 0-1.5h3.995a7.689 7.689 0 0 0-14.45 4.434A7.687 7.687 0 0 0 12 19.686a.75.75 0 0 1 0 1.5 9.188 9.188 0 1 1 7.688-14.214V3.561a.75.75 0 1 1 1.5 0v5.625a.75.75 0 0 1-.75.75h-.47z',
});
